export const adminFinance = {
  seo: {
    title: "Admin és pénzügy — Bespire AI asszisztens",
    description:
      "Üzleti áttekintés, havi zárás, teljesítmény-riport, kapacitás- és költségterv. A Bespire AI asszisztens segít átlátni a vállalkozásodat.",
  },
  hero: {
    badge: "Admin és pénzügy",
    title: "Lásd tisztán a vállalkozásodat — havi zárás egy beszélgetésben",
    subtitle:
      "Üzleti áttekintés, kapacitástervezés, költség- és bevétel-riport. A Bespire AI napi szinten dolgozik a számokon, hogy te a szakmádra koncentrálhass. A rendszer maga kezeli az online és a helyszíni fizetéseket; a számlázást nem a Bespire végzi.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    dashboard: {
      title: "Heti üzleti zárás",
      subtitle: "24. hét · 2026. jún. 8–14.",
      kpis: [
        { label: "Bevétel", value: "528 000 Ft", delta: "+11%", positive: true },
        { label: "Foglalások", value: "47", delta: "+3", positive: true },
        { label: "Kihasználtság", value: "78%", delta: "+6%", positive: true },
        { label: "Költség", value: "94 500 Ft", delta: "kategorizálva", positive: true },
      ],
      chartLabel: "Napi bevétel",
      chartDays: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      chartValues: [64, 82, 51, 96, 108, 88, 39],
      chartUnit: "eFt",
      aiNote: "A szerdai kihasználtság alacsonyabb — javaslat csoportos órára készen áll.",
    },
  },
  paperwork: {
    title: "A papírmunka, ami eltűnik a heti listádról",
    subtitle: "Ugyanaz a munka — csak nem te csinálod.",
    before: {
      label: "Amit eddig te csináltál",
      items: [
        "Excel-táblák bevétel-követéshez",
        "Excel-táblák költség-kategorizáláshoz",
        "Kézi kapacitás-tervezés a naptárban",
        "Havi számok összeszedése a döntésekhez",
        "Emlékezni, kinek, mikor kell visszahívni",
        "Külön eszközök a könyvelőnek",
      ],
    },
    after: {
      label: "Amit a Bespire csinál helyetted",
      items: [
        "Heti és havi bevétel-riport, AI-kommentárral",
        "Automatikus költség-kategorizálás feltöltött bizonylatok alapján",
        "Kapacitás-elemzés és üres slot-riasztás",
        "Havi zárási csomag egy kattintással",
        "Tudja, kinek, mikor, hányszor küldött üzenetet",
        "Könyvelő-csomag export PDF-ben és Excelben",
      ],
    },
  },
  lifecycle: {
    title: "Egy foglalás útja — a bevételig",
    subtitle: "A foglalástól a zárásig — mindegyik lépés vagy automatikus, vagy egy kattintás.",
    steps: [
      { icon: "Calendar", label: "Foglalás", description: "Ügyfél időpontot foglal" },
      { icon: "CreditCard", label: "Fizetés", description: "Online vagy helyszínen a rendszerben" },
      { icon: "Eye", label: "Követés", description: "Fizetési státusz élőben" },
      { icon: "Bell", label: "Emlékeztető", description: "Késedelemnél automatikusan" },
      { icon: "BarChart3", label: "Riport", description: "Heti-havi zárás egy csomagban" },
    ],
  },
  mocks: {
    title: "Így néznek ki az outputok",
    subtitle: "Két konkrét üzleti kimenet: egy heti áttekintés és egy havi zárási riport.",
    invoice: {
      badge: "Heti áttekintés",
      number: "24. hét",
      date: "2026. jún. 8–14.",
      due: "",
      fromLabel: "Időszak",
      from: "2026. jún. 8–14.",
      toLabel: "Összesítés",
      to: "Kata Regeneráció",
      items: [
        { label: "Foglalások száma", amount: "47" },
        { label: "Online fizetések", amount: "312 000 Ft" },
        { label: "Helyszíni fizetések", amount: "216 000 Ft" },
      ],
      totalLabel: "Heti bevétel",
      total: "528 000 Ft",
      status: "Rendezve",
    },
    report: {
      badge: "Havi zárás (minta)",
      week: "Június 2026",
      kpis: [
        { label: "Bevétel", value: "1 847 000 Ft", delta: "+12%" },
        { label: "Kihasználtság", value: "78%", delta: "+6%" },
        { label: "Új ügyfél", value: "18", delta: "+5" },
      ],
      aiCommentTitle: "AI kommentár",
      aiComment: "A havi bevétel 12%-kal nőtt. A szerdai délelőtti kihasználtság csökken — javaslat reggeli kedvezményes csomag 45 inaktív ügyfélnek.",
      actionLabel: "Terv készítése",
    },
  },
  chat: {
    title: "Havi zárás egy beszélgetésben",
    subtitle: "Nem kell megnyitnod egy Excel-t sem.",
    chat: {
      title: "Admin asszisztens",
      online: "Online",
      messages: [
        { role: "user" as const, content: "Zárjuk le a hónapot. Küldjük a könyvelőnek." },
        { role: "assistant" as const, content: "Kész, itt van a csomag:", list: [
          "📊 Bevétel: 1 847 000 Ft (28 nap)",
          "💳 42 foglalás — online és helyszíni fizetések",
          "📎 PDF kimutatás + Excel a könyvelőnek csatolva",
        ] },
        { role: "user" as const, content: "Küldd el neki emailben, és állítsd be jövő hónapra is." },
        { role: "assistant" as const, content: "Elküldtem az info@konyveled.hu címre. Havi automatikus küldés beállítva minden hónap 5-én. ✅" },
      ],
    },
  },
  integrations: {
    title: "Csatlakozik a meglévő folyamataidhoz",
    subtitle: "A Bespire kiegészíti a könyvelődet és a pénzügyi rutinjaidat — nem cseréli le őket.",
    items: [
      { label: "Könyvelő email", type: "Havi zárás" },
      { label: "Banki export (CSV)", type: "Költség" },
      { label: "Google Sheets", type: "Riport export" },
    ],
  },
  extras: {
    title: "Miért működik",
    items: [
      { icon: "Puzzle", title: "Nem lecseréli, kiegészíti", description: "A meglévő könyvelő- és pénzügyi folyamataiddal dolgozik együtt." },
      { icon: "Clock", title: "30–60 perc admin naponta", description: "megspórolva — a szakmádra tudsz koncentrálni." },
      { icon: "Shield", title: "GDPR, EU szerver", description: "Az ügyfél- és pénzügyi adataid nem hagyják el az EU-t." },
      { icon: "MessageSquare", title: "Magyar szabályokra", description: "KATA, ÁFA, számla-kötelezettségek — ismeri a hazai kontextust." },
    ],
  },
  crossLinks: {
    title: "Az admin nem áll magában",
    subtitle: "Ugyanaz az AI, ami a számaidat követi, tudja a foglalásaidat, az ügyfeleidet, a marketingedet is.",
  },
  cta: {
    title: "Vedd le a papírmunkát a válladról",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
